import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import "./Intervention.css";
import withAuth from "../../components/withAuth";
import { withRouter } from "react-router-dom";
import {
    fieldValueChange,
    getStartedWorkOrder,
    setImputationRedirectionModalOpenned,
    interventionsIsLoading,
} from "../../redux/intervention/interventionActions";
import {
    stopAndValidateIntervention,
    submitInterventionInDb,
    cancelPreview,
} from "../../redux/intervention/interventionEditionActions";
import { loadCurrentTimeSlot } from "../../redux/imputationInterventionRel/imputationInterventionRelActions";
import FooterFixedOnScreen from "../Layout/FooterFixedOnScreen";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import VariableTab from "../../components/Interventions/InterventionTabs/VariableTab";
import moment from "moment";
import ImputationRedirectionModal from "../../components/Interventions/ImputationRedirectionModal";
import { getStateAccessor } from "../../lib/evaluateStringAsCodeHelper";
import DetailTab from "../../components/Interventions/InterventionTabs/DetailTab";
import ReportTab from "../../components/Interventions/InterventionTabs/ReportTab";
import { getCurrentFunctionName } from "../../performanceModeManager";
import UpdatingBlocModal from "../../components/Interventions/UpdatingBlocModal";

class InterventionPreview extends Component {
    constructor(props) {
        super(props);

        this.state = {
            blocs: this.getBlocs(),
            getBlocs: this.getBlocs.bind(this),
            mapOfBlocIdAndBlocIndex: {},
        };

        if (!this.props.intervention) this.props.history.push("/interventions");
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.intervention) nextProps.saveIntervention(nextProps.intervention, nextProps.blocs);

        let state = prevState;
        state.blocs = prevState.getBlocs();
        return state;
    }

    getBlocs() {
        let blocs = [];
        this.props.blocs.forEach((b) => {
            let bt = this.props.blocTypes.find((bt) => bt.id === b.type_id);

            if (!bt) {
                console.error("Type de bloc introuvable", b, bt, this.props.blocTypes);
                return [];
            }

            if (bt.display_to_customer) blocs.push(b);
        });

        return blocs;
    }

    fieldValueChange(blocId, fieldId, value) {
        this.props.fieldValueChange(
            blocId,
            fieldId,
            value,
            this.props.blocs,
            this.props.activeUser.id,
            this.props.intervention
        );
    }

    addOrRemoveBloc() {
        //On ne peut pas créer de bloc en preview
    }

    cancelPreview() {
        this.props.cancelPreview(this.props.history, false);
    }

    closeImputationRedirectionModal() {
        this.props.setImputationRedirectionModalOpenned(false);
        this.props.history.push("/interventions/intervention");
    }

    stopAndValidate() {
        this.props.interventionsIsLoading(true);
        getStartedWorkOrder()
            .then((intervention) => {
                if (intervention)
                    this.props
                        .loadCurrentTimeSlot(intervention.report_block_ids, this.props.blocTypes, this.props.activeUser)
                        .then((timeSlot) => {
                            this.props.interventionsIsLoading(false);

                            if (timeSlot) {
                                timeSlot.endDate = moment().seconds(0).milliseconds(0);
                                timeSlot.endTime = moment().seconds(0).milliseconds(0);

                                this.props.stopAndValidateIntervention(
                                    this.props.intervention,
                                    timeSlot,
                                    this.props.blocs,
                                    this.props.activeUser,
                                    this.props.blocTypes,
                                    this.props.history,
                                    getStateAccessor(this.props)
                                );
                                this.forceUpdate();
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            this.props.interventionsIsLoading(false);
                        });
            })
            .catch((err) => {
                console.error(err);
                this.props.interventionsIsLoading(false);
            });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.intervention.internalState !== nextProps.intervention.internalState ||
            this.props.intervention.state !== nextProps.intervention.state ||
            this.props.blocs.length !== nextProps.blocs.length ||
            this.state.blocs.length !== nextState.blocs.length ||
            this.props.updatingBloc !== nextProps.updatingBloc
        );
    }

    deleteBloc(blocId) {
        let confirmation = window.confirm("Êtes-vous sûr(e) de vouloir supprimer ce bloc?");

        if (!confirmation) return;

        let blocs = [...this.props.blocs.filter((b) => !b.deleted)];

        let bloc = blocs.find((b) => b.mobile_id === blocId);

        if (!bloc) {
            console.error("Bloc introuvable");
            return;
        }

        let blocType = this.props.blocTypes.find((bt) => bt.id === bloc.type_id);

        bloc.deleted = true;

        this.forceUpdate();
        this.props.addOrRemoveBloc(blocType.id, bloc.mobile_id, false);
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        if (!this.props.intervention) return <div />;

        let removableCategories = [];

        this.props.blocTypes
            .filter((bt) => bt.published)
            .map((bt) => bt.category_id)
            .forEach((c) => {
                if (removableCategories.every((rc) => rc.id !== c.id) && c.removable) removableCategories.push(c);
            });
        let categoryTabs = [];

        removableCategories
            .sort((c) => c.sequence)
            .forEach((c, i) => {
                categoryTabs.push({
                    name: c.name,
                    content: (
                        <VariableTab
                            key={i}
                            category={c}
                            fieldValueChange={this.fieldValueChange.bind(this)}
                            addOrRemoveBloc={this.addOrRemoveBloc.bind(this)}
                        />
                    ),
                });
            });
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <div className="container-with-footer col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <DetailTab />
                    <ReportTab
                        fieldValueChange={this.fieldValueChange.bind(this)}
                        addOrRemoveBloc={this.addOrRemoveBloc.bind(this)}
                    />
                    {categoryTabs.map((sc) => sc.content)}
                </div>
                <FooterFixedOnScreen>
                    <div className="row">
                        <div className="col-lg-1 col-md-2 col-sm-4 col-6">
                            <Fab onClick={this.cancelPreview.bind(this)} color="primary" className="div-center">
                                <Icon>arrow_back</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">Annuler aperçu</span>
                        </div>
                        <div className="offset-lg-10 col-lg-1 offset-md-8 col-md-2 offset-sm-4 col-sm-4 col-6">
                            <div className="center">
                                {this.props.intervention.state === "performed" ? (
                                    <div>
                                        <Fab
                                            onClick={this.stopAndValidate.bind(this)}
                                            className="green-button div-center"
                                        >
                                            <Icon>check</Icon>
                                        </Fab>
                                        <span className="floating-btn-text span-center">Valider</span>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </FooterFixedOnScreen>
                <ImputationRedirectionModal closeModal={this.closeImputationRedirectionModal.bind(this)} />
                <UpdatingBlocModal
                    updatingBloc={this.props.updatingBloc}
                    fieldValueChange={this.fieldValueChange.bind(this)}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        blocTypes: state.interventions.blocTypes,
        intervention: state.intervention.currentIntervention,
        blocs: state.intervention.blocs,
        updatingBloc: state.intervention.updatingBloc,
        activeUser: state.activeUser,
        loggedEmployee: state.loggedEmployee.loggedEmployee,
        fluidBottles: state.liquidBottles.myLiquidBottles,
        sppFound: state.analyseRisques.sppFound,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fieldValueChange: (blocId, fieldId, value, blocs, userId, intervention) =>
            dispatch(fieldValueChange(blocId, fieldId, value, blocs, userId, intervention)),
        stopAndValidateIntervention: (intervention, timeSlot, blocs, user, blocTypes, history, stateAccessor) =>
            dispatch(
                stopAndValidateIntervention(intervention, timeSlot, blocs, user, blocTypes, history, stateAccessor)
            ),
        saveIntervention: (intervention, blocs) => submitInterventionInDb(intervention, blocs),
        cancelPreview: (history, imputationRedirection) => dispatch(cancelPreview(history, imputationRedirection)),
        loadCurrentTimeSlot: (blocs, blocTypes, user) => dispatch(loadCurrentTimeSlot(blocs, blocTypes, user)),
        setImputationRedirectionModalOpenned: (value) => dispatch(setImputationRedirectionModalOpenned(value)),
        interventionsIsLoading: (value) => dispatch(interventionsIsLoading(value)),
    };
};

export default compose(withRouter, withAuth, connect(mapStateToProps, mapDispatchToProps))(InterventionPreview);
